"use client";
import { createContext, useContext, useState } from "react";

interface contextProps {
  children: React.ReactNode;
}

const SearchContext = createContext({});

export const SearchProvider: React.FC<contextProps> = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const updateSearchQuery = (query: string) => {
    setSearchQuery(query);
  };

  return (
    <SearchContext.Provider value={{ searchQuery, updateSearchQuery }}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => {
  return useContext<any>(SearchContext);
};
